/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AppConstants } from './common/variable';
import { isNil } from 'lodash';
import { CurrentAccountService } from './services/currentaccount.service';
import { HelperService } from './services/helper-service.service';
import { forkJoin } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { ApiResponse } from './common/model/ApiResponse';
import { ConstantService } from './common/service/constant.service';
import { NbIconLibraries } from '@nebular/theme';
import { FeromonService } from './services/feromon.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  private alive = true;
  constructor(
    private currentAccountSvc: CurrentAccountService,
    private helperService: HelperService,
    private constantService: ConstantService,
    private iconLibraries: NbIconLibraries,
    private feromonService: FeromonService
  ) {
    this.iconLibraries.registerFontPack('fas', { iconClassPrefix: 'fa', packClass: 'fas' });
    this.iconLibraries.registerFontPack('far', { iconClassPrefix: 'fa', packClass: 'far' });
    this.iconLibraries.registerFontPack('fab', { iconClassPrefix: 'fa', packClass: 'fab' });
    this.iconLibraries.setDefaultPack('fas'); // <---- set as default
  }

  ngOnInit(): void {
    // this.analytics.trackPageViews();
    // localStorage.clear();
    const userData = localStorage.getItem(AppConstants.Storage.User);
    if (!isNil(userData)) {
      AppConstants.User = JSON.parse(userData);
      this.constantService.getAllConstant().subscribe();
      forkJoin(
        this.currentAccountSvc.getCurrentAccountList(1, 15000),
        this.helperService.cropList(),
        this.helperService.cropVarityList(),
        this.feromonService.getCategories()
      )
        .pipe(takeWhile(() => this.alive))
        .subscribe(([accountData, cropData, varietyList, categories]: [ApiResponse<any>, ApiResponse<any>, ApiResponse<any>, any]) => {

          if (accountData.IsSuccess) {
            AppConstants.App.CurrentAccountList = accountData.Data;
          }
          if (cropData.IsSuccess) {
            AppConstants.OfflineData.CropList = cropData.Data;
          }
          if (cropData.IsSuccess) {
            AppConstants.OfflineData.CropVarityList = varietyList.Data;
          }
          AppConstants.App.categoryList = categories.Data;
        });
    }
  }
}
